module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "has-text-left"
  }, [(!_vm.continueButton) ? _c('div', [_c('h5', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t("please_enter_amount")))]), _vm._v(" "), _c('div', {
    staticClass: "field has-addons"
  }, [_c('p', {
    staticClass: "control"
  }, [_c('a', {
    staticClass: "button is-static"
  }, [_vm._v(_vm._s(_vm.currencySymbols[_vm.User.wallet.currency].symbol))])]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|currency|min_value:' + (_vm.APM == 'mulixPayretailers' ? '50' : '1')),
      expression: "'required|currency|min_value:' + (APM == 'mulixPayretailers' ? '50' : '1')"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.amount),
      expression: "amount"
    }],
    class: {
      'input': true, 'is-danger': _vm.errors.has('amount')
    },
    attrs: {
      "name": "amount",
      "type": "text",
      "data-vv-as": _vm.translations.text.amount,
      "placeholder": _vm.translations.text.amount
    },
    domProps: {
      "value": (_vm.amount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.amount = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('amount')),
      expression: "errors.has('amount')"
    }],
    staticClass: "help is-danger",
    class: {
      'has-text-right': _vm.Language == 'fa' || _vm.Language == 'ar'
    }
  }, [_vm._v(_vm._s(_vm.errors.first('amount')))])])]), _vm._v(" "), (_vm.APM) ? _c(_vm.methods[_vm.APM], {
    tag: "component",
    on: {
      "request": _vm.sendMulixRequest
    }
  }) : _vm._e()], 1) : (_vm.payment.URL != '') ? _c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.frameLoaded),
      expression: "!frameLoaded"
    }],
    staticClass: "is-center"
  }, [_vm._v("Loading...")]), _vm._v(" "), _c('iframe', {
    staticClass: "tile mulix-frame",
    attrs: {
      "src": _vm.payment.URL,
      "frameborder": "0",
      "id": "pay_embed"
    },
    on: {
      "load": _vm.frameLoad
    }
  })]) : (_vm.payment.error) ? _c('div', [_vm._v("\n    There was an error contacting the payment provider. Please try again.\n  ")]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3795847d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/finance/deposit-methods/Mulix.vue
// module id = 748
// module chunks = 0